import { FormEvent, useContext, useState } from "react"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { criptografarDado } from "../../helpers"
import { conquistaParams } from "../../interfaces/conquista"
import { NivelResposta } from "../../interfaces/conquistaNivel"
import { atualizarNivel, cadastrarNivel } from "../../services/conquistaNivel"
import { Button } from "../Styles"
import DivSituacao from "../DivSituacao"

function ModalNivelConquista({ conquista }: conquistaParams) {

    const { atualizarDados, modalExibir } = useContext(ModalEstadoContext)

    const [adicionandoNivel, setAdicionandoNivel] = useState(false)

    const [titulo, setTitulo] = useState("")
    const [descricao, setDescricao] = useState("")
    const [valor, setValor] = useState("")
    const [nivelSelecionado, setNivelSelecionado] = useState<NivelResposta>()
    const [situacao, setSituacao] = useState("Ativo")

    const editarNivel = (nivel: NivelResposta) => {
        setNivelSelecionado(nivel)

        setTitulo(nivel.titulo)
        setDescricao(nivel.descricao || "")
        setValor(nivel.valor || "")
        setSituacao(nivel.situacao)

        setAdicionandoNivel(true)
    }

    const onUpdateNivel = async (e: FormEvent) => {
        e.preventDefault()

        if (!nivelSelecionado) {
            return toast.error("Nível não encontrado.")
        }

        try {
            const payload = {
                titulo,
                descricao,
                valor,
                situacao,
                idConquista: criptografarDado(conquista!.id.toString()),
            }

            const resposta = await atualizarNivel(
                criptografarDado(nivelSelecionado.id.toString()),
                payload
            )

            if (resposta.status === 200) {
                atualizarDados()

                toast.success("Nível atualizado com sucesso.")

                setNivelSelecionado(undefined)
                setTitulo("")
                setDescricao("")
                setValor("")
                setSituacao("Ativo")

                setAdicionandoNivel(false)
            }
        } catch {
            toast.error("Erro ao atualizar nível.")
        }
    }

    const onSubmitNivel = async (e: FormEvent) => {
        e.preventDefault()

        if (!conquista) return toast.error("Conquista não encontrada.")

        try {
            const payload = {
                titulo,
                descricao,
                valor,
                idConquista: criptografarDado(conquista.id.toString()),
            }

            const resposta = await cadastrarNivel(payload)

            if (resposta.status === 201) {
                atualizarDados()
                toast.success("Nível cadastrado com sucesso.")

                setTitulo("")
                setDescricao("")
                setValor("")

                setAdicionandoNivel(false)
            }
        } catch {
            toast.error("Erro ao cadastrar nível.")
        }
    }

    return (
        <div className="fundoModal">
            <section className='containerModalCentro'>
                <span id='novoContainerTitulo'>
                    <p>Níveis da Conquista</p>
                </span>
                <form id='formModalNovo' onSubmit={nivelSelecionado ? onUpdateNivel : onSubmitNivel}>
                    {!adicionandoNivel ? (
                        <>
                            <section>
                                <span>
                                    <label>Conquista</label>
                                    <input
                                        type="text"
                                        placeholder="Titulo"
                                        defaultValue={conquista?.titulo}
                                        disabled
                                    />
                                </span>
                            </section>

                            <div>
                                <div>
                                    <table id='tabelaListaContainer'>
                                        <thead>
                                            <tr>
                                                <th id='ladoEsquerdoContent' align='left'>Título</th>
                                                <th align='center'>Metas</th>
                                                <th align='center'>Situação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {conquista?.conquistaNivels?.map((nivel) => (
                                                <tr key={nivel.id} onClick={() => editarNivel(nivel)}>
                                                    <td align='left' className='primeiraColuna'>
                                                        {nivel.titulo}
                                                    </td>
                                                    <td align='center'>{nivel.valor}</td>
                                                    <td align='center' id='ladoDireitoContent'>
                                                        <DivSituacao
                                                            texto={`${nivel.situacao.charAt(0).toUpperCase()}${nivel.situacao.substring(1)}`}
                                                            cor={nivel.situacao.toLowerCase()}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <span id="botoesContainer">
                                <Button
                                    type="button"
                                    cor="cancelar"
                                    isLoading={false}
                                    onClick={() => {
                                        setNivelSelecionado(undefined)
                                        modalExibir("")
                                    }}
                                >
                                    Voltar
                                </Button>

                                <Button
                                    type="submit"
                                    cor="salvar"
                                    isLoading={false}
                                    onClick={() => setAdicionandoNivel(true)}
                                >
                                    Novo Nível
                                </Button>
                            </span>
                        </>
                    ) : (
                        <>
                            <section>
                                <span>
                                    <label>Título</label>
                                    <input
                                        type="text"
                                        placeholder="Título"
                                        value={titulo}
                                        onChange={(e) => setTitulo(e.target.value)}
                                        maxLength={100}
                                        required
                                    />
                                </span>
                            </section>

                            <section>
                                <span>
                                    <label>Descrição</label>
                                    <textarea
                                        placeholder="Descrição"
                                        value={descricao}
                                        onChange={(e) => setDescricao(e.target.value)}
                                        maxLength={500}
                                        style={{ resize: "none" }}
                                        required
                                    />
                                </span>
                            </section>

                            <section>
                                <span>
                                    <label>Meta</label>
                                    <input
                                        type="number"
                                        placeholder="Meta"
                                        value={valor}
                                        onChange={(e) => setValor(e.target.value)}
                                        required
                                    />
                                </span>
                            </section>

                            {nivelSelecionado && (
                                <section>
                                    <span>
                                        <label>Situação</label>
                                        <select
                                            value={situacao}
                                            onChange={(e) => setSituacao(e.target.value)}
                                        >
                                            <option value="Ativo">Ativo</option>
                                            <option value="Inativo">Inativo</option>
                                        </select>
                                    </span>
                                </section>
                            )}

                            <span id="botoesContainer">
                                <Button
                                    type="button"
                                    cor="cancelar"
                                    isLoading={false}
                                    onClick={() => {
                                        setNivelSelecionado(undefined)
                                        setTitulo("")
                                        setDescricao("")
                                        setValor("")
                                        setSituacao("Ativo")
                                        setAdicionandoNivel(false)
                                    }}
                                >
                                    Voltar
                                </Button>

                                <Button
                                    type="submit"
                                    cor="salvar"
                                    isLoading={false}
                                >
                                    {conquista ? "Atualizar" : "Cadastrar"}
                                </Button>
                            </span>
                        </>
                    )}
                </form>
            </section>
        </div>
    );
}

export default ModalNivelConquista;